import React from 'react';
import PropTypes from 'prop-types';
import {Stack} from "@mui/material";

import {SkeletonBar as Bar} from "components/Product/Table/ListingRowsSkeleton";

import {Cell, Row} from "./EnrichmentTable";

EnrichmentRowsSkeleton.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.string).isRequired,
    rows: PropTypes.number,
};

const CELLS = {
    product: () => (
        <Stack direction="row" alignItems="flex-start" gap="16px">
            <Stack direction="row" alignItems="center" gap="8px">
                <Bar dark width={16} height={16}/>
                <Stack gap="8px">
                    <Bar dark width={84} height={112} sx={{borderRadius: '8px'}}/>
                    <Bar width={84} height={20}/>
                </Stack>
            </Stack>
            <Stack gap="8px" sx={{flex: 1}}>
                <Bar width={48} height={20}/>
                <Bar dark height={16}/>
                <Bar height={14} width="60%"/>
                <Bar height={14} width="80%"/>
            </Stack>
        </Stack>
    ),
    scoring: () => (
        <Stack gap="8px">
            <Bar dark width={40} height={20}/>
            <Bar height={14}/>
            <Bar dark width={64} height={20}/>
            <Bar height={14}/>
        </Stack>
    ),
    variants: () => (
        <Stack direction="row" flexWrap="wrap" gap="4px">
            <Bar width={40} height={20}/>
            <Bar width={40} height={20}/>
            <Bar width={48} height={20}/>
            <Bar width={32} height={20}/>
        </Stack>
    ),
    attributes: () => (
        <Stack gap="12px">
            <Bar dark height={40}/>
            <Bar dark height={40}/>
        </Stack>
    ),
    action: () => <Bar dark height={40}/>,
    pictures: () => (
        <Stack direction="row" gap="8px">
            {[0, 1, 2, 3].map((index) => <Bar key={index} dark width={84} height={112} sx={{borderRadius: '8px'}}/>)}
        </Stack>
    ),
};
CELLS.suggestion = CELLS.attributes;

/**
 * First-load placeholder of the enrichment table, cell by cell under the same columns
 * as the real rows so nothing moves when they arrive.
 */
function EnrichmentRowsSkeleton({columns, rows = 5}) {
    return Array.from({length: rows}, (_, index) => (
        <Row key={index} data-testid="enrichment-row-skeleton">
            {columns.map((column) => (
                <Cell key={column} column={column}>
                    {CELLS[column]()}
                </Cell>
            ))}
        </Row>
    ));
}

export default EnrichmentRowsSkeleton;
